import React, { useState, useEffect, useCallback } from "react";

//ReCaptcha
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

//JQuery
import $ from 'jquery';

//Functions
import { generateUid, addError, removeErrorConfirm, validateEmail, getGeoInfo, facebookEvent, ga4Event, sibAdd, getCookie } from "../../utils/generaFunctions";
import { cardCvvStyle, cardNumberStyle, cardYearStyle, cardMonthStyle, planTextSelector, planNameSelector, promoTextSelector } from "../../utils/recurly.props";
import { addPaymentError, getAddonList, validateAndSubmitSubs } from "../../utils/recurly.functions";

//Recurly Lib
import {useRecurly, useCheckoutPricing, CardNumberElement, CardYearElement, CardMonthElement, CardCvvElement } from '@recurly/react-recurly';

//AutoComplete Lib
import {usePlacesWidget} from "react-google-autocomplete";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";

//Countries and States/Province
import { allCountries } from 'country-region-data';

//MUI Lib
import { Grid, Link, Typography } from "@mui/material";
import {default as MuiButton} from "@mui/material/Button";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import FormControl from '@mui/material/FormControl';

//Custom Components
import InputText from "../../components/input-text/input-text.component";
import InputSelect from "../../components/input-select/input-select.component";
import Checkbox from "../../components/checkbox/checkbox.component";
import Button from "../../components/button/button.component";

//Custom Hooks
import useWindowDimensions from "../../hooks/useWindowDimensions";

//email validation
import emailMisspelled, { all } from "email-misspelled"

import "./checkout.styles.scss";
import { useRef } from "react";
import { sibEvent, sibTrackEmail, sibUpdateContact } from "../../utils/sib.functions";
import Popover from "../../components/popover/popover.component";
import InputSwitch from "../../components/input-switch/input-switch.component";
import { getDays, getMonths, getYears } from "../../utils/getData";

export const Checkout = (props) => {
  const {height, width} = useWindowDimensions();
  const [isUnderMd, setIsUnderMd] = useState(false);
  const [sibEmail, setSibEmail] = useState();
  const [sibEmailGift, setSibEmailGift] = useState();
  const [supportCountries, setSupportCountries] = useState(["CA", "US"/*, "AU"*/, "GB"]);
  const uuid = generateUid();

  //ReCaptcha
  const { executeRecaptcha } = useGoogleReCaptcha();
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }
    const token = await executeRecaptcha('purchase');
    return token;
  }, [executeRecaptcha]);


  //email validation
  const emailChecker = emailMisspelled({ domains: all });

  //Query string variables
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var gift = urlParams.has('gift') ? urlParams.get('gift') : "";
  const plan = urlParams.has('plan') && urlParams.get('plan') ? urlParams.get('plan') : window.location = "/subscribe/";
  const wedDate = urlParams.has('weddingDate') ? urlParams.get('weddingDate') : "";
  const [customText, setCustomText] = useState('');
  var [addOnList, setAddOnList] = useState("");
  const promo = window.sessionStorage.getItem("promo") || getCookie("promo") || urlParams.get('promo');
  const addonCode = promo? `${promo.toLowerCase().replace("off","")}`: "";
  const [bonus, setBonus] = useState(urlParams.has('bonus') ? `${urlParams.get('bonus')}${addonCode?","+addonCode:""}` : `${addonCode}`);
  const dev = urlParams.has('dev')? urlParams.get('dev'): null;

  //Due Date Min and Max
  const [days, setDays] = useState(getDays());

  //Country and Province/State
  const [userLocation, setUserLocation] = useState([]);
  const [countryText, setCountryText] = useState("US");
  const [filteredCountries, setFilteredCountries] = useState(allCountries);
  const [filteredStates, setFilteredStates] = useState([]);

  //form variables
  const [couponText, setCouponText] = useState("");
  const [installment, setInstallment] = useState(false);
  const planName = planNameSelector(plan);
  const planText = planTextSelector(plan, gift, promo);
  const [progress, setProgress] = useState(false);
  const initFormData = {
    plan: plan,
    addon: "",
    bonus:"",
    pay_source:"",
    currency: "USD",
    email: "",
    shirt: "",
    shoe: "M 8-9",
    wed_date: wedDate,
    wed_year: wedDate && wedDate.split("-")[0],
    wed_month: wedDate && Number(wedDate.split("-")[1]),
    wed_day: wedDate &&  Number(wedDate.split("-")[2]),
    first_mom: "",
    baby_gender:"",
    ship_fname: "",
    ship_lname: "",
    ship_street:"",
    ship_apt:"",
    ship_city:"",
    ship_country:"",
    ship_state:"",
    ship_zip:"",
    ship_phone:"",
    ship_method:"standard",
    bill_country:"",
    bill_zip:"",
    code:"",
    applied_code:"",
    gift: gift?"yes":"",
    personal_msg_checked:false,
    giftee_email:"",
    personal_msg:"",
    market_consent:false,
    price: 0,
    recurly_token:"",
    purchase_ready: false,
    first_six: "",
    action_token_result: "",
    dev: dev,
    csrf_token: $('input[name=csrf_token]').val(),
    recaptcha_value: ""
  }
  const savedFormData = JSON.parse(window.localStorage.getItem('formData'));
  const [formData, setFormData] = useState(savedFormData && 
                              (Object.keys(savedFormData).length === Object.keys(initFormData).length)? 
                              {...savedFormData, dev:dev, plan: plan, bonus:"", code:"", applied_code:"",
                                wed_date:wedDate?wedDate: savedFormData.wed_date, 
                                wed_year: wedDate?wedDate.split("-")[0]:savedFormData.wed_year,
                                wed_month: wedDate?Number(wedDate.split("-")[1]):savedFormData.wed_month,
                                wed_day: wedDate?Number(wedDate.split("-")[2]):savedFormData.wed_day,
                                shoe: "M 8-9",
                                pay_source:"", gift: gift?"yes":"", first_six: "", action_token_result: "", csrf_token: $('input[name=csrf_token]').val(), recaptcha_value: ""}:
                              initFormData );
  const [opened, setOpened] = useState({
    account_details: true,
    customization: false,
    shipping_addr: false,
    payment_details: false,
    bill_info:false,
    plan_details:true,
  })

  const [valids, setValids] = useState({
    account_details: false,
    shipping_addr: false,
    bill_info:false,
  });

  const [ cardName, setCardName ] = useState("");
  const [ cardBrand, setCardBrand ] = useState("");
  const [landed, setLanded] = useState(true);
  const [expanded, setExpanded] = useState("account_details");
  const emailRef = useRef(null);
  const shipFnameRef = useRef(null);
    
  //Recurly
  const recurly = useRecurly();
  const risk = recurly.Risk();
  const [threeDSecure, setThreeDSecure] = useState(null);
  const [recurlyError, setRecurlyError] = useState(null);
  var [{ price, loading }, setCheckoutPricing] = useCheckoutPricing({
    subscriptions: [{
      plan: plan,
      quantity: 1,
      currency: 'USD',
      tax_code: "digital",
      vat_number: ""
    }]
  }, setRecurlyError);
  const formRef = React.useRef();
  //Recurly Error
useEffect(()=>{
  if (recurlyError && !loading) {
    setProgress(false);
    if(recurlyError.message.toLowerCase().includes("coupon") && formData.applied_code){
      if(price.now.discount === "0.00"){
        setFormData((previous)=>({...previous, applied_code:""}));
        addError(document.getElementById("coupon_input"), recurlyError.message, document.getElementById("coupon_input").previousElementSibling.getElementsByClassName("checkout-input")[0].getElementsByTagName("div")[0]);
        ga4Event("checkout_error", "coupon", "invalid coupon", recurlyError.message);

      }else {
        removeErrorConfirm();
      }
    } else if (recurlyError.message){
      if(recurlyError.message.includes("Couldn't find Plan")){
        window.location.href = "/";
      }
    }
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
},[recurlyError, loading])

//AutoComplete
const { ref } = usePlacesWidget({
  apiKey: "AIzaSyCJl-aJxA49ksIx-X_m90GcEMUJJrhoyik", //PROD
  //apiKey:"AIzaSyBzO_LgVc_V8TJmoiA1x9pZp2wTwI5rsFg",
  options:{
    types: ["address"],
    componentRestrictions: { country: supportCountries },
    fields: ["address_components", "geometry"],
  },
  onPlaceSelected: (place) => handlePlaceSelected(place)
});
const {
  placesAutocompleteService,
} = usePlacesService({
  apiKey: "AIzaSyCJl-aJxA49ksIx-X_m90GcEMUJJrhoyik", //PROD
  //apiKey:"AIzaSyBzO_LgVc_V8TJmoiA1x9pZp2wTwI5rsFg",
});
const [autocompleteReady, setAutocompleteReady] = useState(false);
useEffect(()=>{
  if(placesAutocompleteService){
    placesAutocompleteService.getPlacePredictions({
      input:"143 Drumlin Cir"
    }, (array, status)=>{
      if(status === 'OK') {
        setAutocompleteReady(true);
      }else {
        setAutocompleteReady(false);
      }
    })
  }
},[placesAutocompleteService])

const handlePlaceSelected = (place) => {
  if(place){
    const components = place.address_components;
    let street = "";
    let zip = "";
    let city = "";
    let state = "";
    let country = "";
    setFormData((previous)=>({
      ...previous,
      ship_street: "",
      ship_zip: "",
      ship_city: "",
      ship_state: "",
      ship_country: "",
    }))
    for (const component of components.reverse()) {
      const componentType = component.types[0];
      switch (componentType) {
        case "street_number": {
          street = `${component.long_name} ${street}`;
          break;
        }
        case "route": {
          street += component.short_name;
          break;
        }
        case "postal_code": {
          zip = `${component.long_name}${zip}`;
          break;
        }
        case "postal_code_suffix": {
          zip += `-${component.long_name}`;
          break;
        }
        case "locality":
          city = component.long_name;
          break;
        case "postal_town":
          city = component.long_name;
          break;
        case "administrative_area_level_1": {
          if(country !== "GB") state = component.short_name;
          break;
        }
        case "country":
          country = component.short_name;
          break;
        default:
          break;
      }
    };
    setFormData((previous)=>({...previous, ship_street:street, ship_zip: zip, ship_city: city, ship_state:state, ship_country: country}));
  }
} 

//3-D Secure
useEffect(()=>{
  window.threeDSecure = threeDSecure;
  if(threeDSecure){
    threeDSecure.on('token', function (token) {
      setFormData((previous)=>({...previous, action_token_result:token.id, purchase_ready:true}));
      removeErrorConfirm();
      ga4Event("checkout", "3d secure","succeed", formData.email);
      threeDSecure.remove();
    });

    threeDSecure.on('error', function (error) {
        addPaymentError(document.getElementById(`${formData.pay_source}-checkout`),  "Error", error.message);
        ga4Event("checkout", "3d secure","failed",  formData.email + ": " + error.message);
        threeDSecure.remove();
    });
    window.threeDSecure = threeDSecure;
    threeDSecure.attach(document.querySelector('#auth_3d'));
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
},[threeDSecure]);

  const [payPal, setPayPal] = useState("");
  const [ payPalAvailable, setPayPalAvailable ] = useState(false);
  //Paypal
  useEffect(()=>{
    if(payPal && payPal._callbacks && !payPal._callbacks.$token){
      payPal.on("token", function(token) {
        setFormData((previous)=>({...previous, recurly_token:token.id, pay_source:"paypal", purchase_ready:true}));
      });
      payPal.on('ready', () => {
        setPayPalAvailable(true);
      });
    } else if(payPal && payPal._callbacks && !payPal._callbacks.$error && expanded==="payment_details"){
      payPal.on("error", function(err) {
        var errorText = "";
        if (err.fields) {
          errorText = 'The following fields appear to be invalid: ' + err.fields.join(', ');
        } else {
          if (err.cause){
            errorText = 'Some error has occured, see console for details. ' + err.message + "| Embedded error: " + err.cause;
          } else {
            errorText = 'Some error has occured, see console for details. ' + err.message;
          }
        }
        setFormData((previous)=>({...previous, pay_source:""}));
        addPaymentError(document.getElementById("paypal-checkout"),  "Error", "PayPal checkout failed. Please use another method or try again.")
        ga4Event("checkout_error", "3rd party error", "paypal",errorText);
      });
      payPal.on("cancel", function(event) {
        setFormData((previous)=>({...previous, pay_source:""}));
          addPaymentError(document.getElementById("paypal-checkout"),  "Canceled", "PayPal checkout cancelled. Please use another method or try again.")
          ga4Event("checkout_error", "3rd party canceled", "paypal", "canceled the payment");
      });
    }
  },[payPal, expanded]);

  //Apple
  const [ applePay, setApplePay] = useState("");
  const [ appleAvailable, setAppleAvailable] = useState(false);
  const [ priceLogApple, setPriceLogApple] = useState("");
  useEffect(()=>{
    if(applePay && applePay._callbacks && !applePay._callbacks.$token){
      applePay.on("token", function(token) {
        setFormData((previous)=>({...previous, recurly_token:token.id, pay_source:"applepay", purchase_ready:true}));
      });
      applePay.on("ready", function() {
        setAppleAvailable(true);
      })
    } else if(applePay && applePay._callbacks && !applePay._callbacks.$error && expanded==="payment_details" ){
      applePay.on("error", function(err) {
        var errorText = "";
        if (err.fields) {
          errorText = 'The following fields appear to be invalid: ' + err.fields.join(', ');
        } else {
          if (err.cause){
            errorText = 'Some error has occured, see console for details. ' + err.message + "| Embedded error: " + err.cause;
          } else {
            errorText = 'Some error has occured, see console for details. ' + err.message;
          }
        }
        ga4Event("checkout_error", "3rd party error", "applepay", errorText);
        setFormData((previous)=>({...previous, pay_source:""}));
        addPaymentError(document.getElementById("applepay-checkout"),  "Error", "ApplePay checkout failed. Please use another method or try again.")
      });
      applePay.on("cancel", function(event) {
        ga4Event("checkout_error", "3rd party canceled", "applepay", "canceled the payment");
        setFormData((previous)=>({...previous, pay_source:""}));
        addPaymentError(document.getElementById("applepay-checkout"),  "Canceled", "ApplePay checkout cancelled. Please use another method or try again.")
      });
    }
  },[applePay, uuid, expanded]);

  const [ venmo, setVenmo] = useState("");
  const [ venmoAvailable, setVenmoAvailable ] = useState(false);
  const [ priceLogVenmo, setPriceLogVenmo] = useState("");
  //Venmo
  useEffect(()=>{
    if(venmo && venmo._callbacks && !venmo._callbacks.$token){
      venmo.on("token", function(token) {
        setFormData((previous)=>({...previous, recurly_token:token.id, pay_source:"venmo", purchase_ready:true}));
      });
      venmo.on("ready", function() {
        setVenmoAvailable(true);
      })
    } else if(venmo && venmo._callbacks && !venmo._callbacks.$error && expanded==="payment_details"){
      venmo.on("error", function(err) {
        setFormData((previous)=>({...previous, pay_source:""}));
        var errorText = "";
        if (err.fields) {
          errorText = 'The following fields appear to be invalid: ' + err.fields.join(', ');
        } else {
          if (err.cause){
            errorText = 'Some error has occured, see console for details. ' + err.message + "| Embedded error: " + err.cause;
          } else {
            errorText = 'Some error has occured, see console for details. ' + err.message;
          }
        }
        ga4Event("checkout_error", "3rd party error", "venmo", errorText);
        addPaymentError(document.getElementById("venmo-checkout"),  "Error", errorText);
      });
      venmo.on("cancel", function(event) {
        setFormData((previous)=>({...previous, pay_source:""}));
        addPaymentError(document.getElementById("venmo-checkout"),  "Canceled", "Venmo checkout cancelled. Please use another method or try again.")
        ga4Event("checkout_error", "3rd party canceled", "venmo", "canceled the payment");
      });
    }

  },[venmo, uuid, expanded]);

  //Google Pay
  const [ googlePay, setGooglePay] = useState("");
  const [ googlePayAvailable, setGooglePayAvailable] = useState(false);
  const [ priceLogGooglePay, setPriceLogGooglePay] = useState("");

  useEffect(()=>{
    if(googlePay){
      if(googlePay._callbacks) googlePay._callbacks = {};
      googlePay.on("token", function(token) {
        setFormData((previous)=>({...previous, recurly_token:token.id, pay_source:"googlepay", purchase_ready:true}));
      });
      googlePay.on("ready", function(googlePayButton) {
        document.getElementById('googlepay-checkout').innerHTML = "";
        document.getElementById('googlepay-checkout').appendChild(googlePayButton);
        setGooglePayAvailable(true);
      })
      googlePay.on("error", function(err) {
        setFormData((previous)=>({...previous, pay_source:""}));
        addPaymentError(document.getElementById("googlepay-checkout"),  "Error", "GooglePay checkout failed. Please use another method or try again.")
        var errorText = "";
        if (err.fields) {
          errorText = 'The following fields appear to be invalid: ' + err.fields.join(', ');
        } else {
          if (err.cause){
            errorText = 'Some error has occured, see console for details. ' + err.message + "| Embedded error: " + err.cause;
          } else {
            errorText = 'Some error has occured, see console for details. ' + err.message;
          }
        }
        ga4Event("checkout_error", "3rd party error", "googlepay", errorText);
      });
      googlePay.on("cancel", function(event) {
        setFormData((previous)=>({...previous, pay_source:""}));
        addPaymentError(document.getElementById("googlepay-checkout"),  "Canceled", "GooglePay checkout cancelled. Please use another method or try again.")
        ga4Event("checkout_error", "3rd party canceled", "googlepay", "canceled the payment");
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[googlePay]);

  /************** Hooks *************/
  //Constructor
  useEffect(()=>{
    function autoRefresh() {
      window.location = window.location.href;
    }
    setInterval(()=>autoRefresh(), 3600 * 1000);
    //mtm25off event;
    if(promo && promo!=="none") handleCouponApplied(promo);
    let bonusStr = bonus;
    if(addonCode){
      bonusStr = bonusStr.replace(`,${addonCode}`,"");
      bonusStr = bonusStr.replace(`${addonCode}`,"");
      if(bonusStr.length>0) {
        setBonus(bonusStr + `,${addonCode}`);
        bonusStr = bonusStr + `,${addonCode}`;
      } else {
        setBonus(`${addonCode}`);
        bonusStr = `${addonCode}`;
      }
    } else {
      setBonus(bonusStr);
    }
      getGeoInfo().then((locationData)=>{
        setSupportCountries(locationData.country);
        setUserLocation({country:locationData.country_code, region:locationData.region_code, postal:locationData.postal});
        if(locationData.country_code === "AU"){
          //setCountryText("AU");
        } else if(locationData.country_code === "GB"){
          setCountryText("UK");
        }
        if(!formData.ship_country){
          if(locationData.country_code === "CA"){
            setFormData((previous)=>({...previous, ship_country:"CA", bill_country:"CA"}));
          } else if(locationData.country_code === "AU"){
            //setFormData((previous)=>({...previous, ship_country:"AU", bill_country:"AU"}));
          } else if(locationData.country_code === "GB"){
            setFormData((previous)=>({...previous, ship_country:"GB", bill_country:"GB"}));
          } else {
            setFormData((previous)=>({...previous, ship_country:"US", bill_country:"US"}));
          }
      }
    });
    if(bonusStr){
      getAddonList(plan).then((addonData)=>{
        if(addonData.success){
          let addOnList = addonData.add_ons;
          setAddOnList(addOnList);
          }
          setBonus(bonusStr);
      })
    }
    if(!payPal){
      setPayPal(recurly.PayPal({
        display: {displayName: `Miss To Mrs Box: ${planName}`},
        braintree: { clientAuthorization: 'production_8h2d68qv_4d8x87xpxqk6pvm6'}
      }));
    }
    if(!applePay && window.ApplePaySession){
      setApplePay(recurly.ApplePay({
        country: 'US',
        currency: 'USD',
        label: `Miss To Mrs Box: ${planName}`,
        recurring: true,
        total: 35,
        braintree: {
            clientAuthorization: "production_8h2d68qv_4d8x87xpxqk6pvm6" 
            //clientAuthorization: "production_x6vzsgkp_4d8x87xpxqk6pvm6" 
        }
      }));
    } else if(!googlePay && !window.ApplePaySession){
      setGooglePay(recurly.GooglePay({
        currency: 'USD',
        country: 'US',
        total: '35',
        googleMerchantId: 'BCR2DN4TWKILTWKN',
        billingAddressRequired: true,
      }))
    }
    //Venmo is enabled
    if(!venmo){
      setVenmo(recurly.Venmo({
          display: {
            amount: '35.00',
            currency: 'USD',
            displayName: "Miss To Mrs Box",
            locale: 'en_US',
          },
          braintree: {
            //clientAuthorization: "production_8h2d68qv_4d8x87xpxqk6pvm6", //FROM PROD
            clientAuthorization: "production_gpsqmbch_4d8x87xpxqk6pvm6", //From My Braintree ID
            webAuthentication: true
          },
          form: document.querySelector('#subscribe_form')
      }));
    }
    setFilteredCountries(allCountries.filter((country)=>{return ["CA", "US", "GB"/*, "AU"*/].includes(country[1])}));

      let data = {
        email: formData.email.trim().replaceAll(" ",""),
        fname: formData.ship_fname,
        lname: formData.ship_lname,
        city: formData.ship_city,
        state: formData.ship_state,
        country: formData.ship_country,
        zip_code: formData.ship_zip,
        phone: formData.ship_phone,
        gift: formData.gift, 
        price: 10,
        plan: formData.plan};
      facebookEvent("fb_init_checkout", data); 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  useEffect(()=>{
    let modal = document.getElementById("custom-popup");
    let modalContent = document.getElementById("modal-content");
    modal.onclick = function(e) {
      modal.style.display = "none"; 
    }
    if(planText && planText.includes("popup-inside")){
      window.document.getElementById("popup-inside").onclick= () =>{
        if(width < 960){
          modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/whats_inside_mobile.jpg";
          modalContent.style.maxWidth = "320px";
        } else {
          modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/whats_inside_desktop.jpg";
          modalContent.style.maxWidth = "700px";
        }
        modal.style.display = "flex"; 
      };
    }
    window.document.getElementById("popup_size_guide").onclick= () =>{
      if(width < 960){
        if(userLocation.country === "GB"){
          modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/size-guide-mobile-uk.jpg";  
        } else if(userLocation.country === "AU_INVALID"){
          modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/size-guide-mobile-au.jpg";  
        } else {
          modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/size-guide-mobile.jpg";
        }
        modalContent.style.maxWidth = "320px";
      } else {
        if(userLocation.country === "GB"){
          modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/size-guide-desktop-uk.jpg";  
        } else if(userLocation.country === "AU_INVALID"){
          modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/size-guide-desktop-au.jpg";  
        } else {
          modalContent.src = "https://misstomrsbox.com/wp-content/themes/misstomrs/imgs/size-guide-desktop.jpg";
        }
        modalContent.style.maxWidth = "550px";
      }
      modal.style.display = "flex"; 
    };
    modal.onclick = function(e) {
      modal.style.display = "none"; 
    }
  },[planText, width])
  //fordata save in local storage
  useEffect(()=>{
    window.localStorage.setItem('formData', JSON.stringify(formData));
    let validCheck = {
      account_details: true,
      shipping_addr: true,
      bill_info:true,
    };
    if(!validateEmail(formData.email) || (formData.personal_msg_checked && !validateEmail(formData.giftee_email))){
      validCheck.account_details=false;
    }
      let ship_addr_ids = ["ship_fname", "ship_lname", "ship_street", "ship_city", "ship_country", "ship_state", "ship_zip"]
      ship_addr_ids.forEach((ship_addr_id)=>{
        if(!formData[ship_addr_id]){
          if(!(formData.ship_country==="GB" && ship_addr_id === "ship_state")){
            validCheck.shipping_addr=false;
          }
        }
      })
      if(!formData.bill_country || !formData.bill_zip){
        validCheck.bill_info = false;
      }
      setValids(validCheck);
  },[formData]);

  //Coupon event
  useEffect(()=>{
    if(formData.applied_code && price && price.now && price.now.subscriptions !== "0.00"){
      ga4Event("checkout", "coupon applied", "N/A", `${formData.applied_code}, discount: $${price.now.discount}`);
      promoTextSelector(formData.applied_code).then((text)=>{
        setCouponText(text);
      }); 
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.applied_code, price && price.now && price.now.discount])

  //email address saved ga4 event
  useEffect(()=>{
    if(formData.market_consent && validateEmail(formData.email)){
      sibAdd(formData.email, 146);
      ga4Event("checkout", "email address saved for marketting", "N/A", `$${formData.email}`);
    }
  },[formData.email, formData.market_consent])

  //Gift check
  useEffect(()=>{
    if(formData.gift && validateEmail(formData.email) && emailChecker(formData.email).length === 0 && userLocation.country && userLocation.postal &&(formData.email !== sibEmailGift)){
      setSibEmailGift(formData.email);
      ga4Event("checkout", "gift option checked", "N/A", `$${formData.email}`);
      setTimeout(()=>{
        sibUpdateContact(formData.email, "MTM_GIFTER:true,MTM_GIFT_COUNTRY:" + userLocation.country + ",MTM_GIFT_ZIP:" + userLocation.postal);
      }, 5000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[formData.gift, formData.email, userLocation, emailChecker]);

  //Gift personal message
  useEffect(()=>{
    if(!formData.gift && formData.personal_msg_checked){
      setFormData((previous)=>({
        ...previous,
        gift: "yes"
      }))
    }
    if (!formData.personal_msg_checked){
      setFormData((previous)=>({
        ...previous,
        giftee_email: "",
        personal_msg:""
      }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[formData.personal_msg_checked])

  //Customization Text
  useEffect(()=>{
    //let text = `${formData.shirt? formData.shirt.toUpperCase():""}${formData.shirt && formData.shoe? " | ":""}${formData.shoe? `${formData.shoe.toUpperCase().replace(" "," ("+countryText+" ")})`:""}${(formData.wed_date) && (formData.shoe || formData.shirt)? " | ":""}${formData.wed_date? formData.wed_date:""}`
    let text = `${formData.shirt? formData.shirt.toUpperCase():""}${(formData.wed_date) && (formData.shoe || formData.shirt)? " | ":""}${formData.wed_date? formData.wed_date:""}`
    setCustomText(text);
  },[formData.wed_date, formData.shirt, formData.shoe, countryText])

  //Installment check
  useEffect(()=>{
    let bonusStr = bonus.replace(",installment-4","");
    bonusStr = bonusStr.replace("installment-4","");
    if(installment){
      if(bonusStr.length>0) {
        setBonus(bonusStr + ",installment-4");
      } else {
        setBonus("installment-4");
      }
    } else {
      setBonus(bonusStr);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[installment]);

  //Bonus
  useEffect(()=>{
    let availableBonusStr = "";
    if(addOnList.length>0){
      let bonusArray = bonus && bonus.split(",");
      if(bonusArray) {
          bonusArray.forEach((bonus)=>{
          if(addOnList.includes(bonus)){
              let bonusStr = bonus;
              if(addOnList.includes(`promo-${bonus}`)) bonusStr = `promo-${bonus}`;
              if(availableBonusStr){
                availableBonusStr += `,${bonusStr}`;
              }else {
                availableBonusStr = bonusStr;
              }
          }
        });
      }
    } else {
      let bonusArray = bonus && bonus.split(",");
      if(bonusArray) {
          bonusArray.forEach((bonus)=>{
            let bonusStr = `promo-${bonus}`;
            if(bonus.includes(`installment`)) bonusStr = `${bonus}`;
            if(availableBonusStr){
              availableBonusStr += `,${bonusStr}`;
            }else {
              availableBonusStr = bonusStr;
            }
        });
      }
    }
    setFormData((previous)=>({...previous, bonus:availableBonusStr}));
  },[addOnList, bonus])

  //set states based on country & add shipping add on to price
  useEffect(()=>{
    let tempState = formData.ship_state;
    var addOn = "";
    const countryCode = formData.ship_country;
    const zipPostal = formData.ship_zip;
    let valid = false;
    setFormData(previous => ({...previous ,ship_state:""}));

    if(filteredCountries.filter((country)=>{return country[1]===formData.ship_country})[0]){
      setFilteredStates(
        filteredCountries.filter(
          (country)=>{
            return country[1]===formData.ship_country})[0][2]
            .map((state)=>{  
              if(state[1]===tempState) valid = true;
              return {value: state[1], label:state[0]}
            })
      );
    }
    if(countryCode === "GB"){
      valid = true;
    }
    if(valid) {
      setFormData(previous => ({...previous  ,ship_state:tempState}));
      if (countryCode === "US") {
        addOn = "us-shipping";
      } else if (countryCode === "CA") {
          addOn = "ca-shipping";
      }else if (countryCode === "AU") {
          addOn = "eu-shipping";
      }else if (countryCode === "GB") {
          addOn = "uk-shipping";
      }
      if(addOn){
        setCheckoutPricing(previous=>({
          ...previous, subscriptions: [{
            plan: plan,
            quantity: 1,
            currency: 'USD',
            tax_code: "digital",
            vat_number: "",
            addons: [{code:addOn, quantity: 1}],
            }],
            address:{
              country: countryCode,
              postal_code: zipPostal
            }
        }))
        setFormData((previous)=>({...previous,addon:addOn}));
      } else {
        setCheckoutPricing(previous=>({
          ...previous, subscriptions: [{
            plan: plan,
            quantity: 1,
            currency:'USD'}],
            address:{
              country: countryCode,
              postal_code: zipPostal
            }
        }))
        setFormData((previous)=>({...previous,addon:""}));
      }
    } else {
      setCheckoutPricing(previous=>({
        ...previous, subscriptions: [{
          plan: plan,
          quantity: 1,
          currency:'USD'}],
          address:{
            country: countryCode,
            postal_code: zipPostal
          }
      }))
      setFormData((previous)=>({...previous,addon:""}));
    }
  },[filteredCountries, formData.ship_country, formData.ship_state, formData.ship_zip, plan, setCheckoutPricing])

  //sync billing info to shipping info
  useEffect(()=>{
    if(!opened.bill_info)setFormData(previous => ({...previous, bill_country: formData.ship_country, bill_zip: formData.ship_zip}));
    else setFormData(previous => ({...previous, bill_country: "", bill_zip: ""}))
  },[formData.ship_country, formData.ship_zip, opened.bill_info])

  //phone number fix
  useEffect(()=>{
    let val = formData.ship_phone;
    let corrected = val.replace(/([^+0-9]+)/gi, '');
    corrected = corrected.charAt(0) + corrected.substring(1).replaceAll("+","");
    if(val !== corrected){
      setFormData((previous)=>({...previous, ship_phone:corrected}));
    }
  },[formData.ship_phone])

  //scroll to expanded description
  useEffect(()=>{
    if(!landed){
      setTimeout(()=>{
        if(expanded==="account_details"){
          emailRef.current && emailRef.current.focus();
        } else if(expanded==="shipping_addr"){
          shipFnameRef.current.focus();
          document.getElementById("ship_street").setAttribute("autocomplete","shipping street-address");
        }
        document.getElementById(expanded).scrollIntoView({behavior: 'smooth'});
      },500);
    } else {
      emailRef.current.focus();
      window.ApplePaySession && emailRef.current.setSelectionRange(0,999);
      setLanded(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[expanded])

  //Recurly Hooks
  //Apple Pay redefinition and price check
  useEffect(()=>{
    if(price.now && (((price.now.total !== priceLogApple) && appleAvailable)||((price.now.total !== priceLogVenmo) && venmoAvailable)||((price.now.total !== priceLogGooglePay) && googlePayAvailable))){
      if(appleAvailable){
        setApplePay(recurly.ApplePay({
          country: 'US',
          currency: 'USD',
          recurring: true,
          label: "Miss To Mrs Box: " + planName, 
          total: price.now.total,
          braintree: {
            clientAuthorization: "production_8h2d68qv_4d8x87xpxqk6pvm6" 
            //clientAuthorization: "production_x6vzsgkp_4d8x87xpxqk6pvm6" 
          }
        }));
        setPriceLogApple(price.now.total);
      }
      if(venmoAvailable){
        setVenmo(recurly.Venmo({
          display: {
            amount: '35.00',
            currency: 'USD',
            displayName: "Miss To Mrs Box",
            locale: 'en_US',
          },
          braintree: {
            //clientAuthorization: "production_8h2d68qv_4d8x87xpxqk6pvm6", //FROM PROD
            clientAuthorization: "production_gpsqmbch_4d8x87xpxqk6pvm6", //From My Braintree ID
            webAuthentication: true
          },
          form: document.querySelector('#subscribe_form')
        }));
        setPriceLogVenmo(price.now.total);
      }
      if(googlePayAvailable){
        /*setGooglePay(recurly.GooglePay({
          currency: 'USD',
          country: 'US',
          total: price.now.total,
          googleMerchantId: 'BCR2DN4TWKILTWKN',
          billingAddressRequired: true
        }));*/
        setPriceLogGooglePay(price.now.total);
      }
    }
    if(!loading && price.now.items[0]){
      if(document.getElementById("box-price")) document.getElementById("box-price").innerHTML = `$${price.now.items[0].plan.replace(".00","")}`;
    }
    if(price.now&&price.now.total&&formData.price!==price.now.total){
      setFormData((previous)=>({...previous, price:price.now.total}));
    }
  },[appleAvailable, formData, googlePayAvailable, loading, planName, price.now, priceLogApple, priceLogGooglePay, priceLogVenmo, recurly, venmoAvailable]);

  //screen size
  useEffect(()=>{
    if(width <= 900){
        setIsUnderMd(true);
    } else {
        setIsUnderMd(false);
    }
  },[height, width]) 
  //purchase hook
  useEffect(()=>{
    if(formData.purchase_ready){
      if(formRef){
        formRef.current.dispatchEvent(
          new Event("submit", { cancelable: true, bubbles: true })
        ); 
      }
      setFormData((previous)=>({...previous,purchase_ready:false, action_token_result:""}));
    }
  },[formData.purchase_ready, formData.pay_source]);

  //date set up
  useEffect(()=>{
    if(formData.wed_year && formData.wed_month && formData.wed_day){
      let wed_date = `${formData.wed_year}-${formData.wed_month.toString().padStart(2,'0')}-${formData.wed_day.toString().padStart(2,'0')}`;
      setFormData((previous)=>({...previous, wed_date:wed_date}));
    } 
  }, [formData.wed_year, formData.wed_month, formData.wed_day])

  useEffect(()=>{
      if(formData.wed_month === 2){
          let d = new Date(formData.wed_year, formData.wed_month-1, 29);
          let yearMatches = d.getUTCFullYear() === formData.wed_year;
          let monthMatches = d.getUTCMonth() === formData.wed_month-1;
          let dayMatches = d.getUTCDate() === 29;
          if(yearMatches&&monthMatches&&dayMatches) setDays(getDays(29));
          else setDays(getDays(28));
      }else if(formData.wed_month===6 ||formData.wed_month===9 ||formData.wed_month===11 ||formData.wed_month===4) {
          setDays(getDays(30));
      } else {
          setDays(getDays(31));
      }
  }, [formData.wed_year, formData.wed_month])
  /************** Handlers *************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    let recaptcha_token = await handleReCaptchaVerify();
    let emailEl = document.getElementById("email");
    setProgress(true);
    removeErrorConfirm();
    if((!valids.account_details && !validateEmail(emailEl.value)) || !valids.bill_info || !valids.shipping_addr){
      setProgress(false);
      if(!valids.account_details) {
        setExpanded("account_details");
        addError(document.getElementById("email").parentNode, "Valid email is required", document.getElementById("email").parentNode);
        ga4Event("checkout_error", "validation error", "email" , `${emailEl.value?emailEl.value:"empty"}`);
      }else if(!valids.shipping_addr) {
        setExpanded("shipping_addr");
        var valid=true;
        let ship_addr_ids = ["ship_fname", "ship_lname", "ship_street", "ship_city", "ship_country", "ship_state", "ship_zip"]
        ship_addr_ids.forEach((ship_addr_id)=>{
          if(!(formData.ship_country==="GB" && ship_addr_id === "ship_state" ) && !formData[ship_addr_id] && valid){
            let element = document.getElementById(ship_addr_id).parentNode;
            addError(element, element.parentElement.getElementsByTagName("label")[0].innerHTML + " is required", (ship_addr_id === "ship_country" || ship_addr_id ==="ship_state")?document.getElementById(ship_addr_id):element);
            ga4Event("checkout_error", "validation error", "shipping address",  element.parentElement.getElementsByTagName("label")[0].innerHTML);
            valid=false;
          }
        })
      } else if(!valids.bill_info) {
        let errorFileds = [];
        if(!formData.bill_country) errorFileds.push("Country");
        if(!formData.bill_zip) errorFileds.push("Zip / Postal Code");
        let errorMsg = `These fields are required: ${errorFileds.toString().replaceAll(",",", ")}`
        addPaymentError(document.getElementById("creditcard_payment"), "Sorry, we are unable to process your payment", errorMsg);
        ga4Event("checkout_error", "validation error", "billing address", errorMsg);
      }
    } else if(formData.pay_source === "paypal" || formData.pay_source === "applepay" || formData.pay_source === "googlepay" || formData.pay_source === "venmo"){
      ga4Event("checkout", "payment attemped", "non credit card", formData.pay_source);
      validateAndSubmitSubs(formData, cardBrand, 
        (errorMessage, action_token_id=null)=>{
          setProgress(false); 
          addPaymentError(document.getElementById(`${formData.pay_source}-checkout`),  "Error", errorMessage);
          ga4Event("checkout_error", "3rd party error", formData.pay_source, errorMessage);
          if(action_token_id){
            setThreeDSecure(risk.ThreeDSecure({
              actionTokenId: action_token_id
            }));
          } else {
            setThreeDSecure(null);
          }
        }
      );
    }else {
      recurly.token(formRef.current, (err, token) => {
        if (err) {
          setProgress(false);
          let replacedErr = "These fields are required: " + err.fields.toString().replaceAll(",",", ")
                              .replace("number","Card Number")
                              .replace("month","Expiry Month")
                              .replace("year","Expiry Year")
                              .replace("cvv", "Security Code")
                              .replace("first_name, last_name", "Name On Card")
                              .replace("last_name", "Last Name")
                              .replace("country", "Country")
                              .replace("postal_code", "Zip / Postal Code");
          addPaymentError(document.getElementById("creditcard_payment"), "Sorry, we are unable to process your payment", replacedErr);
          ga4Event("checkout_error", "payment field validation", "card information", err.fields.toString().replaceAll(",",", "));
        } else {
          setFormData((previous)=>({...previous, recurly_token:formData.action_token_result?formData.recurly_token:token.id, pay_source:"creditcard", recaptcha_value: recaptcha_token}));
          ga4Event("checkout", "payment attemped", "credit card", cardBrand);
          validateAndSubmitSubs(formData, cardBrand, (errorMessage, action_token_id=null)=>{
            setProgress(false); 
            if(errorMessage) addPaymentError(document.getElementById("creditcard_payment"), "Sorry, we are unable to process your payment", errorMessage);
            if(action_token_id){
              setThreeDSecure(risk.ThreeDSecure({
                actionTokenId: action_token_id
              }));
            } else {
              setThreeDSecure(null);
            }
            ga4Event("checkout_error", "recurly error", "card", errorMessage);
          }, "creditcard", formData.action_token_result?formData.recurly_token:token.id, recaptcha_token); 
        }
      });
    }
  };

  const handleChange = event => {
    const target = event.target;
    const name = target.name;
    var value = target.type === 'checkbox' ? target.checked :target.value;
    if(name === "ship_country" || name === "bill_country" ) {
      const selectedCountry = filteredCountries.filter((country)=>{return target.value === country[0]});
      if(selectedCountry.length === 1){
        value = selectedCountry[0][1];
      }
    } else if((formData.ship_country==="US" && name === "ship_zip") || 
              (formData.bill_country==="US" && name === "bill_zip") ) {
      value = target.value.replaceAll(/[^0-9]/g, "").replaceAll("-","");
      if(value.length>5 || target.value.length>5) {
        value = `${value.substring(0,5)}-${value.substring(5,9)}`;
      }
    } 
    removeErrorConfirm(event.target);
    setFormData(previous=>({
      ...previous,
      [name]: value
    }));
  }

  const handleAccordionsChange = (panel) => (event, isExpanded) => {
    if(panel !== expanded){
      if(opened[panel]){
        removeErrorConfirm();
        if((expanded==="account_details" && !valids["account_details"])){
            handleContinueClicked();
        } else if(handleContinueClicked(panel)){
            setExpanded(isExpanded ? panel : false);
          }
      }
    }
  };

  const handleContinueClicked = (panel_entered) => {
    let valid = false;
    let panel = "payment_details";
    if(!opened.customization || (opened.customization && !valids.account_details)) panel = "customization";
    else if(!opened.shipping_addr || !valids.shipping_addr) panel = "shipping_addr";
    else if(!opened.payment_details) panel = "payment_details";
    if(panel_entered && panel_entered.length ) panel = panel_entered;
    let emailEl = document.getElementById("email");
    if(panel==="customization") {
      let gifteeEmailEl = document.getElementById("giftee_email");
      if(!formData.personal_msg_checked && validateEmail(emailEl.value)){
        valid=true;
        let correctedEmail = emailEl.value;
        if(emailChecker(formData.email).length !== 0) {
          correctedEmail = emailChecker(formData.email)[0].corrected;
          ga4Event("checkout_error", "email misspelled fixed", "continue clicked", `${formData.email}->${correctedEmail}` );
        }
        if(formData.gift && validateEmail(formData.email)){
          sibUpdateContact(correctedEmail, "MTM_GIFTER:true,MTM_GIFT_COUNTRY:" + userLocation.country + ",MTM_GIFT_ZIP:" + userLocation.postal);
        }        
      } else if(formData.personal_msg_checked && validateEmail(emailEl.value) && validateEmail(gifteeEmailEl.value)){
        valid=true;
        let correctedEmail = emailEl.gifteeEmailEl;
        let correctedGifteeEmail = emailEl.value;
        if(emailChecker(formData.email).length !== 0) {
          correctedEmail = emailChecker(formData.email)[0].corrected;
          ga4Event("checkout_error", "email misspelled fixed", "continue clicked", `${formData.email}->${correctedEmail}` );
        }
        if(formData.gift){
          sibUpdateContact(correctedEmail, "MTM_GIFTER:true,MTM_GIFT_COUNTRY:" + userLocation.country + ",MTM_GIFT_ZIP:" + userLocation.postal);
        }
        if(emailChecker(formData.giftee_email).length !== 0) {
          correctedGifteeEmail = emailChecker(formData.giftee_email)[0].corrected;
          ga4Event("checkout_error", "giftee email misspelled fixed", "continue clicked", `${formData.giftee_email}->${correctedGifteeEmail}` );
        }
      }else {
        if(!validateEmail(emailEl.value)){
          addError(emailEl.parentNode, "Valid email is required", emailEl.parentNode);
          ga4Event("checkout_error", "validation error", "email",`${emailEl.value?emailEl.value:"empty"}`);
        } else {
          addError(gifteeEmailEl.parentNode, "Valid email is required", gifteeEmailEl.parentNode);
          ga4Event("checkout_error", "validation error", "giftee email",`${gifteeEmailEl.value?gifteeEmailEl.value:"empty"}`);
        }
      }
    } else if (panel ==="shipping_addr" && !valids.shipping_addr && opened.shipping_addr) {
      valid=true;
      let valid_ship = true;
      let ship_addr_ids = ["ship_fname", "ship_lname", "ship_street", "ship_city", "ship_country", "ship_state", "ship_zip"]
      ship_addr_ids.forEach((ship_addr_id)=>{
        if(!(formData.ship_country==="GB" && ship_addr_id === "ship_state" ) && !formData[ship_addr_id] && valid_ship){
          valid_ship = false;
          let element = document.getElementById(ship_addr_id).parentNode;
          addError(element, element.parentElement.getElementsByTagName("label")[0].innerHTML + " is required", (ship_addr_id === "ship_country" || ship_addr_id ==="ship_state")?document.getElementById(ship_addr_id):element);
          ga4Event("checkout_error", "validation error", "shipping address",`${element.parentElement.getElementsByTagName("label")[0].innerHTML}`);
        }
      })
    } else if(panel==="payment_details") {
      valid=true;
      let ship_addr_ids = ["ship_fname", "ship_lname", "ship_street", "ship_city", "ship_country", "ship_state", "ship_zip"]
      ship_addr_ids.forEach((ship_addr_id)=>{
        if(!(formData.ship_country==="GB" && ship_addr_id === "ship_state" ) && !formData[ship_addr_id] && valid){
          valid=false;
          let element = document.getElementById(ship_addr_id).parentNode;
          addError(element, element.parentElement.getElementsByTagName("label")[0].innerHTML + " is required", (ship_addr_id === "ship_country" || ship_addr_id ==="ship_state")?document.getElementById(ship_addr_id):element);
          ga4Event("checkout_error", "validation error", "shipping address",`${element.parentElement.getElementsByTagName("label")[0].innerHTML}`);
        }
      })
      if(valid){
        let phone = formData.ship_phone;
        if(phone && phone.substring(0,2) !== "00" && phone.substring(0,1) !== "+"){
          if(phone.length === 11 && phone.substring(0,1) !=="1"){
            phone = "+44" + phone;
          } else if(phone.length === 10){
            phone = "+1" + phone;
          } else if(phone.length === 9){
            phone = "+61" + phone;
          }
        }
        let attr = "";
        attr += `FIRSTNAME:${formData.ship_fname},LASTNAME:${formData.ship_lname},`;
        attr += `SHIPPING_CITY:${formData.ship_city.toUpperCase()},`;
        if(formData.ship_state) attr += `SHIPPING_ADMINISTRATIVE_AREA:${formData.ship_state.toUpperCase()},`;
        attr += `SHIPPING_REGION_CODE:${formData.ship_country.toUpperCase()},`;
        attr += `SHIPPING_POSTAL_CODE:${formData.ship_zip.toUpperCase()}`;
        if(phone)  attr += `,SMS:${phone}`;
        sibUpdateContact(
          formData.email, 
          attr
        )
        if(!opened.payment_details && phone) sibEvent(formData.email, 'checkout_started_mtm_sms', formData);
        if(!formData.gift && !cardName){
          setCardName(`${formData.ship_fname} ${formData.ship_lname}`);
        }
      }
      if(valid){
        setOpened(previous=>({
          ...previous,
          plan_details: true
        }))
      }
    } else {
      valid=true;
    };
    if(valid){
      setOpened(previous=>({
        ...previous,
        [panel]: true
      }));
      setExpanded(panel);
      if(panel==="payment_details"){
        window.dataLayer.push({ ecommerce: null });
        let item_id = gift? "MTM_SUB_BOX_GIFT" : "MTM_SUB_BOX_NON_GIFT";
        let item_name = gift? "MTM Subscription Box - Gift" : "MTM Subscription Box - NonGift";
        window.dataLayer.push({
            event: "add_shipping_info",
            ecommerce: {
                currency: "USD",
                value: price.now.total,
                items: [
                {
                    item_id: item_id,
                    item_name: item_name,
                    item_variant: plan,
                    index: 0,
                    price: price.now.total,
                    affiliation: "Miss To Mrs Box",
                    currency: "USD",
                    quantity: 1
                }
                ]
            }
        });
      }
    } else if(!valids.account_details){
      setExpanded("account_details");
    } else {
      setExpanded("shipping_addr");
    }
    return valid;
  }

  const handleCouponApplied = (coupon) => {
    if(coupon.length>0 && coupon.length !== 16){
      let couponCode = coupon;
        setCheckoutPricing(previous=>({
          ...previous, coupon: couponCode
        }));
        setFormData((preivous)=>({...preivous, applied_code:couponCode.toUpperCase()}));
    } else if(formData.code.length !== 0 && formData.code.length !== 16){
      if(!formData.code.includes("internal")){
        let couponCode = formData.code;
        setCheckoutPricing(previous=>({
          ...previous, coupon: couponCode
        }));
        setFormData((preivous)=>({...preivous, applied_code:couponCode.toUpperCase()}));
      }
      setFormData((previous)=>({...previous,code:""}));
    } else {
      addError(document.getElementById("coupon_input"), "Please enter the code first", document.getElementById("coupon_input").previousElementSibling.getElementsByClassName("checkout-input")[0].getElementsByTagName("div")[0]);
      ga4Event("checkout_error", "coupon", "validation error", "empty field");
    }
  }


  return (
    <Grid container className="checkout-container">
      <div className="loading-placeholder" style={{display:(progress?"block":"none")}}>
        <div>
        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
        </div>
      </div>
      <Grid item className="checkout-header" xs={12} >
        <img onClick={()=>{window.location.href="/"}} loading="lazy" src={require("../../imgs/checkout_header.png")} alt="checkout_header"/>
      </Grid>
      <Grid item className="checkout-left" md={6} xs={12} order={{ xs: 2, md: 1 }}>
        <form id="subscribe_form" onSubmit={handleSubmit} ref={formRef}>
        <FormControl className="checkout-content flex-vertical">
          {/* Account Details */}
          <Accordion id="account_details" expanded={expanded === 'account_details'} onChange={handleAccordionsChange('account_details')} className="input-category">
            <AccordionSummary className="input-container">
              <Grid container>
                  <Grid item xs={8}><Typography className={"input-title" + ((expanded === 'account_details')||opened.account_details?"":" gray")} >Account Details</Typography></Grid>
                  <Grid item xs={4} sx={{display:opened.account_details && expanded !== 'account_details'?"":"none"}}><Typography className="input-title-change body-link" >Change</Typography></Grid>
                  <Grid item xs={12} sx={{display:opened.account_details && expanded !== 'account_details'?"":"none"}}><Typography className="input-title-info">{formData.email}</Typography></Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails className="flex-vertical">
              <Grid item xs={12} className="description">For invoices, shipping notifications & to manage the subscription account.</Grid>
              <Grid item xs={12}>
                <InputText ref={emailRef} id="email" name="email" value={formData.email} onChange={(e)=>handleChange(e)} className="checkout-input" label="Account Email" 
                onBlur={()=>{
                  let correctedEmail = formData.email;
                  if(emailChecker(formData.email).length !== 0) {
                    correctedEmail = emailChecker(formData.email)[0].corrected;
                    ga4Event("checkout_error", "email misspelled fixed", "continue clicked", `${formData.email}->${correctedEmail}`);
                    setFormData((previous)=>({...previous, email:correctedEmail}));
                  }
                  setTimeout(()=>{
                    sibTrackEmail(correctedEmail, sibEmail, setSibEmail);
  
                  },3000)}} autocorrect="off" autocapitalize="off" spellcheck="false" autocomplete="shipping email"/>
                  <Grid item xs={12} className="box-title">
                    <div loading="lazy" id="gift-icon" alt="gift-icon"/>
                    IS THIS A GIFT?
                  </Grid>
              </Grid> 
                <Grid id="gift_container" container>
                 
                  <Grid item xs={12}  onClick={()=>{
                    if(formData['gift']==="yes"){
                      setFormData({...formData, gift:"", personal_msg_checked:false});
                    } else {
                      setFormData({...formData, gift:"yes"});
                    }
                  }}>
                      <Checkbox id="gift" name="gift" small="yes" checked={formData['gift']} label="Yes, don't include a receipt in the box"/>
                  </Grid>
                  <Grid item xs={12} onClick={()=>{setFormData({...formData, personal_msg_checked:!formData['personal_msg_checked']})}}>
                      <Checkbox id="personal_msg_checked" name="personal_msg_checked" small="yes" checked={formData['personal_msg_checked']} label="Add a gift message"/>
                  </Grid>
                  <Grid id="gift_msg_container" container item xs={12}sx={{display:formData.personal_msg_checked?"":"none"}}>
                    <Grid id="gift_msg_text" item xs={12} className="body-roman" >
                      Recipient will receive an email containing your gift message when the first box has shipped.
                    </Grid>
                    <InputText id="giftee_email" name="giftee_email" value={formData.giftee_email} onChange={(e)=>handleChange(e)} className="checkout-input" label="Recipient’s Email" 
                      onBlur={()=>{
                        let correctedEmail = formData.giftee_email;
                        if(emailChecker(formData.giftee_email).length !== 0) {
                          correctedEmail = emailChecker(formData.giftee_email)[0].corrected;
                          ga4Event("checkout_error", "gifter email misspelled fixed", "continue clicked", `${formData.giftee_email}->${correctedEmail}`);
                          setFormData((previous)=>({...previous, giftee_email:correctedEmail}));
                        }
                      }}/>
                      <InputText id="personal_msg" name="personal_msg" value={formData.personal_msg} onChange={(e)=>handleChange(e)}  className="checkout-input" label="Gift Message (max 200 characters)" multiline={"true"} rows={3}/>
                    </Grid>
                </Grid>
              <Grid item xs={12}>
                <Button className="btn-continue" text="CONTINUE" onClick={handleContinueClicked}></Button>
              </Grid>
            </AccordionDetails>
          </Accordion>
          {/* Customizations */}
          <Accordion id="customization" expanded={expanded === 'customization'} onChange={handleAccordionsChange('customization')} className="input-category">
            <AccordionSummary className="input-container">
              <Grid container>
                <Grid item xs={8}><Typography className={"input-title" + ((expanded === 'customization')||opened.customization?"":" gray")}>Customizations</Typography></Grid>
                <Grid item xs={4} sx={{display:opened.customization && expanded !== 'customization'?"":"none"}}><Typography className="input-title-change body-link">Change</Typography></Grid>
                <Grid item xs={12} sx={{display:opened.customization && expanded !== 'customization' && (formData.shirt||formData.shoe||formData.wed_date)?"":"none"}}>
                  <Typography className="input-title-info">
                    {customText}
                  </Typography></Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails className="flex-vertical">
              <Grid item className="description" xs={12}>Themed boxes do not include groom-specific products.</Grid>
              <Grid container>
                <div id="size-container">
                  <InputSelect id="shirt" name="shirt" no_error="yes" value={formData.shirt} onChange={(e)=>handleChange(e)} className="checkout-input" label="Shirt Size" data={[{value: "S", label:"S"}, {value: "M", label:"M"}, {value: "L", label:"L"}, {value: "XL", label:"XL"}, {value: "2XL", label:"2XL"}, {value: "3XL", label:"3XL"}]}>
                  </InputSelect>
                  <InputSelect id="shoe" name="shoe" no_error="yes" hidden="yes" value={formData.shoe} onChange={(e)=>handleChange(e)} className="checkout-input" label="Shoe Size" data={[{value: "S 6-7", label:`S (${countryText} 6-7)`}, {value: "M 8-9", label:`M (${countryText} 8-9)`}, {value: "L 10-11", label:`L (${countryText} 10-11)`}, {value: "XL 12-13", label:`XL (${countryText} 12-13)`}]}>
                  </InputSelect>
                </div>
                <div id="hanger-container">
                  <div id="hanger_img"/>
                  <Link 
                    id="popup_size_guide">
                    <div id="hanger_txt" className="body-link">Size Guide</div>
                  </Link>
                </div>
                <Grid item xs={12} className="info-label-roman" >
                If you’re not sure, you can add or update later.
                </Grid>
              </Grid>
              <Grid container xs={12} columnSpacing={1} rowSpacing={0}>
                <Grid item xs={12} className="body-roman"><div id="calendar-img"/>Wedding Date (optional)</Grid>
                <Grid item xs={4}>
                  <InputSelect id="wed_year" name="wed_year" no_error="yes" value={formData.wed_year} onChange={(e)=>handleChange(e)} className="checkout-input" label="Year" data={getYears()}>
                  </InputSelect>
                  </Grid>
                <Grid item xs={4}>
                  <InputSelect id="wed_month" name="wed_month" no_error="yes" value={formData.wed_month} onChange={(e)=>handleChange(e)} className="checkout-input" label="Month" data={getMonths()}>
                  </InputSelect>
                  </Grid>
                <Grid item xs={4}>
                  <InputSelect id="wed_day" name="wed_day" no_error="yes" value={formData.wed_day} onChange={(e)=>handleChange(e)} className="checkout-input" label="Day" data={days}>
                  </InputSelect>
                </Grid>
                <Grid item xs={12} className="info-label-roman">
                No wedding date yet, no problem. Start today and we’ll remind you automatically in a few months. You can update this anytime.
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Button className="btn-continue" text="CONTINUE" onClick={handleContinueClicked}></Button>
              </Grid>
            </AccordionDetails>
          </Accordion>
          {/* Shipping Address */}
          <Accordion id="shipping_addr" expanded={expanded === 'shipping_addr'} onChange={handleAccordionsChange('shipping_addr')} className="input-category">
            <AccordionSummary className="input-container">
              <Grid container>
                <Grid item xs={8}><Typography className={"input-title" + ((expanded === 'shipping_addr')||opened.shipping_addr?"":" gray")}>Shipping Details</Typography></Grid>
                <Grid item xs={4} sx={{display:opened.shipping_addr && expanded !== 'shipping_addr'?"":"none"}}><Typography className="input-title-change body-link">Change</Typography></Grid>
                <Grid item xs={12}sx={{display:opened.shipping_addr && expanded !== 'shipping_addr'?"":"none"}}><Typography className="input-title-info">
                {formData.ship_fname} {formData.ship_lname}{formData.ship_fname || formData.ship_lname?",":""} {formData.ship_street}{formData.ship_street?",":""} {formData.ship_apt}<br/>
                {formData.ship_city} {formData.ship_state?formData.ship_state:null} {formData.ship_zip}{formData.ship_city || formData.ship_state || formData.ship_zip?",":""} {formData.ship_country?formData.ship_country:null}
                </Typography></Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails className="flex-vertical">
            <Grid item className="description" xs={12}>Where should we mail the boxes?</Grid>
            <Grid container spacing={1}>              
              <Grid item md={6} xs={12}>
                <InputText ref={shipFnameRef} id="ship_fname" name="ship_fname" value={formData.ship_fname} onChange={(e)=>handleChange(e)} className="checkout-input" label="Recipient's First Name"
                  autocorrect="off" spellcheck="false" autocomplete="shipping given-name" autocapitalize="words"/>
              </Grid>
              <Grid item md={6} xs={12}>
                <InputText id="ship_lname" name="ship_lname" value={formData.ship_lname} onChange={(e)=>handleChange(e)} className="checkout-input" label="Recipient's Last Name"
                  autocorrect="off" spellcheck="false" autocomplete="shipping family-name" autocapitalize="words"/>
              </Grid>
              <Grid item md={7} xs={12} className={autocompleteReady?"":"hidden"}>
                <InputText ref={ref} id={"ship_street"+(autocompleteReady?"":"hidden")} name={"ship_street"+(autocompleteReady?"":"hidden")} value={formData.ship_street} onChange={(e)=>handleChange(e)} className="checkout-input" label="Street Address"
                  autocorrect="off" spellcheck="false" autocomplete="shipping street-address" autocapitalize="words"/>
              </Grid>
              <Grid item md={7} xs={12} className={autocompleteReady?"hidden":""}>
                <InputText id={"ship_street"+(autocompleteReady?"hidden":"")} name={"ship_street"+(autocompleteReady?"hidden":"")} value={formData.ship_street} onChange={(e)=>handleChange(e)} className="checkout-input" label="Street Address"
                  autocorrect="off" spellcheck="false" autocomplete="shipping street-address" autocapitalize="words"/>
              </Grid>
              <Grid item md={5} xs={12}>
                <InputText id="ship_apt" name="ship_apt" value={formData.ship_apt} onChange={(e)=>handleChange(e)} className="checkout-input" label="Apt. / Unit (optional)"
                  autocorrect="off" spellcheck="false" autocomplete="shipping address-line2" autocapitalize="characters"/>
              </Grid>
              <Grid item xs={12}>
                <InputText id="ship_city" name="ship_city" value={formData.ship_city} onChange={(e)=>handleChange(e)} className="checkout-input" label="City"
                  autocomplete="shipping address-level2" autocapitalize="words"/>
              </Grid>
              <Grid item xs={12}>
                <InputSelect id="ship_country" name="ship_country" no_error="yes" 
                  value={formData.ship_country} 
                  onChange={(e)=>handleChange (e)} className="checkout-input" label="Country" 
                  data={filteredCountries.map((country)=>{return {value: country[1], label:country[0]}})}
                  autocomplete="shipping country-name country">
                </InputSelect>
              </Grid>
              <Grid item xs={12} sx={{display:formData.ship_country==="GB"?"none":""}}>
                <InputSelect id="ship_state" name="ship_state" no_error="yes" 
                value={formData.ship_state} 
                onChange={(e)=>handleChange(e)} className="checkout-input" label="State / Province" 
                data={filteredStates}
                autocomplete="shipping address-level1">
                </InputSelect>
              </Grid>
              <Grid item xs={12}>
                <InputText id="ship_zip" name="ship_zip" value={formData.ship_zip} onChange={(e)=>handleChange(e)} className="checkout-input" label="Zip / Postal Code" autocorrect="off" spellcheck="false" autocomplete="shipping postal-code" autocapitalize="characters"/>
              </Grid>
              <Grid item xs={12}>
                <InputText id="ship_phone" name="ship_phone" value={formData.ship_phone} onChange={(e)=>handleChange(e)} className="checkout-input" label="Mobile Number (optional)" autocorrect="off" autocapitalize="off" spellcheck="false" autocomplete="shipping tel"/>
              </Grid>
              <Grid item xs={12} className="info-label-roman">
                By continuing with your mobile number provided, you agree to receive shipping updates & automated marketing texts. Consent is not a condition of purchase. Msg & data rates may apply, frequency varies. Reply HELP for help, STOP to cancel. View <a href="/privacy-policy/">Privacy</a> & <a href="/terms-conditions/">Terms</a>.
              </Grid>
            </Grid>
            <Grid item xs={12}>
                <Button className="btn-continue" text="CONTINUE" onClick={handleContinueClicked}></Button>
              </Grid>
            </AccordionDetails>
          </Accordion>
          {/* Payment Details */}
          <Accordion id="payment_details" expanded={expanded === 'payment_details'} className="input-category">
            <AccordionSummary className="input-container">
              <Grid container>
                <Grid item xs={5}><Typography className={"input-title" + ((expanded === 'payment_details')||opened.payment_details?"":" gray")}>Payment Details</Typography></Grid>
                <Grid item xs={7} sx={{display: expanded !== 'payment_details'?"flex":"none", justifyContent:"end"}}><div>
                  <img alt ="cards" loading="lazy" src={require("../../imgs/allowed_payments.png")} style={{width:"147px"}}/>
                  <Popover image={require("../../imgs/allowed_more_payments.png")} imageWidth="120px" closeTime={3000}>
                    <div id="more_payment"/> 
                  </Popover>
                </div>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails className="flex-vertical">
              <Grid item xs={12} className="description">Decide on “Pay in 4” option & provide payment method.</Grid>
              <Grid item container xs={12} id="order-summary" sx={{display:isUnderMd?"":"none"}}>
                <Grid item xs={12} className="checkout-calculate mobile-show">
                <Grid item className="box-title">
                  <div>Order Summary</div>
                </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={10} className="title">Miss To Mrs Subscription Plan</Grid>
                    <Grid item xs={2} className="value">{price && price.now && price.now.items[0]?`$${price.now.items[0].plan}`:""}</Grid>
                  </Grid>
                  <Grid container item xs={12} className={price && price.now && price.now.discount==="0.00"?"hidden":""}>
                    <Grid item xs={10} className="title">{couponText}</Grid>
                    <Grid item xs={2} className="value">{`-$${price && price.now && price.now.discount}`}</Grid>
                  </Grid>
                  <Grid container item xs={12} className={!bonus.includes("namechange")?"hidden":""}>
                    <Grid item xs={8} className="title">Gift: Name Change Kit</Grid>
                    <Grid item xs={4} className="value"><span className="__crossed">$39.00</span><span className="__bold"> FREE</span></Grid>
                  </Grid>
                  <Grid container item xs={12} className={!bonus.includes("freebridesweatshirt")?"hidden":""}>
                    <Grid item xs={8} className="title">Sign-up bonus: BRIDE Sweatshirt</Grid>
                    <Grid item xs={4} className="value"><span className="__crossed">$59.00</span><span className="__bold"> FREE</span></Grid>
                  </Grid>
                  <Grid container item xs={12} className={price && price.now && price.now.items[0] && price.now.items[0].addons==="0.00"?"hidden":""}>
                    <Grid item xs={10} className="title">Shipping: Green Delivery<Popover className="tooltip-icon" btnOpened="i" title={`<div class="popup-title">Shipping & Delivery</div>`} description={`<div class="popup-desc left"><div><div class="underline">Green Delivery:</div> As we utilize a network of local warehouses, this Ground Delivery option uses up to 90% less CO2 than Air Delivery of goods from remote countries.</div><div><div class="underline">Delivery Timing:</div> orders need 1-2 business days to be ready for dispatch and then most orders are delivered within ${formData.ship_country==="CA"?"5-8":(formData.ship_country==="GB"?"8-10":(formData.ship_country==="AU"?"14-18":"4-6"))} business days after you receive tracking number via email. Remote addresses may require extra time.</div>${formData.ship_country==="CA"?"<div>Ships from Canada, no extra Customs Fees</div>":""}${formData.ship_country==="GB"?"<div>No extra VAT or Customs Fees on delivery</div>":""}${formData.ship_country==="AU"?"<div>No extra Taxes or Customs Fees on delivery</div>":""}</div>`}></Popover></Grid>
                    <Grid item xs={2} className="value">{price && price.now && price.now.items[0]? (price && price.now && price.now.items[0] && price.now.items[0].addons==="0.00"?`FREE`:`$${price.now.items[0].addons}`):""}</Grid>
                  </Grid>
                  <div className="line line__text"></div>
                  <Grid container item xs={12} className={price && price.now && price.now.taxes==="0.00"?"hidden":""}>
                    <Grid item xs={10} className="title">Estimated Sales Tax{/*formData.ship_state === "ON"?"(GST/HST)":"(GST)"*/}<Popover className="tooltip-icon" btnOpened="i" title={`<div class="popup-title">Sales Tax</div>`} description={`<div class="popup-desc"><div>Miss To Mrs is required by local laws to charge applicable sales taxes for online orders and remit them to respective government tax authorities.</div></div>`}></Popover></Grid>
                    <Grid item xs={2} className="value">{`$${price && price.now && price.now.taxes}`}</Grid>
                  </Grid>
                  <Grid container item className="checkout-result mobile-show" xs={12}>
                    <Grid item xs={8} className="title">Total due now (USD)</Grid>
                    <Grid item xs={4} className="value">{`$${price && price.now && price.now.total}`}</Grid>
                </Grid>
                </Grid>
              </Grid>
              {/* Implement "Pay in 4" block on Checkout: https://app.clickup.com/t/86932n69n */}
              <Grid id="installment" container item xs={12} style={{display:plan.includes("-a")?"none":""}}>
              <Grid item className="box-title" >
                <div>Pay in 4 easy payments</div>
              </Grid>
                <Grid item xs={12} className="text-container gap-small">
                <Grid item xs={12} >Split your future recurring subscription payments into smaller interest-free installments.</Grid>
                  <Grid item xs={12} className="image-container" >
                    Works like 
                    <img id="install-img" alt ="installment" loading="lazy" src={require("../../imgs/install_examples.png")}/></Grid>
                  <ul>
                    <li>Pay "Total due now" & get your 1st box</li>
                    <li>Then, pay just ${price && price.next && (Math.round(price.next.total * 25)/100).toFixed(2)} {plan.includes("mo-s")?"once a week":"every " + (plan.includes("mo-e")?"2":"3") + " weeks"}</li>
                    <li>Get your next box after 4 easy payments</li>
                  </ul>
                  <Grid container item xs={12}>
                    <InputSwitch 
                      value ={installment}
                      onChange = {()=>setInstallment(!installment)}
                      label={`YES, pay in 4 payments of $${price && price.next && (Math.round(price.next.total * 25)/100).toFixed(2)}`}/>
                      <Grid className="info-label-roman" item xs={12}>No pre-approval or credit check required</Grid>
                  </Grid>
              </Grid>
                </Grid>
                
              <Grid container xs={12} spacing={1} sx={{display:"none"}}>
                <Grid item paddingLeft={"0!important"} xs={9}>
                  <InputText id="code" name="code" value={formData.code} onChange={(e)=>handleChange(e)} className="checkout-input" label="Coupon Code"/>
                </Grid>
                <Grid item xs={3} id={isUnderMd?"coupon_input":""}>
                  <Button className="btn-reverse" text="APPLY" onClick={handleCouponApplied}></Button>
                </Grid>

              </Grid>
              <Grid container id="payment-container">
                <Grid item className="box-title">
                  <div>EXPRESS PAYMENT METHODS</div>
                </Grid>
                <Grid container className="express-border">
                  <Grid container spacing={1} className={"express-container"}>
                    <Grid item xs={12} sx={{display:payPalAvailable?"":"none"}}>
                      <MuiButton id="paypal-checkout" className="express-payment" variant="contained" sx={{backgroundColor:"#FFD070!important", boxShadow:"none"}}  onClick={() => {removeErrorConfirm(); payPal.start()}}><img loading="lazy" alt="paypal" src={require("../../imgs/pay_paypal.png")}/></MuiButton>
                    </Grid>
                    <Grid item xs={12} sx={{display:appleAvailable?"":"none"}}>
                      <MuiButton id="applepay-checkout" sx={{backgroundColor:"#fff!important", border:"1px solid #000", boxShadow:"none"}} className="express-payment" variant="contained" onClick={() => {removeErrorConfirm();applePay.begin()}}><img loading="lazy" alt="applepay" src={require("../../imgs/pay_applepay.png")}/></MuiButton>
                    </Grid>
                    <Grid item xs={12} sx={{display:(venmoAvailable && (supportCountries === "US"))?"":"none", boxShadow:"none"}}>
                      <MuiButton id="venmo-checkout" className="express-payment" variant="contained"  onClick={() => {removeErrorConfirm();venmo.start()}}><img loading="lazy" alt="venmo" src={require("../../imgs/pay_venmo.png")}/></MuiButton>
                    </Grid>
                    <Grid item xs={12} sx={{display:googlePayAvailable?"flex":"none"}} >
                      <MuiButton id="googlepay-checkout" className="express-payment"
                        sx={{backgroundColor:"black!important", boxShadow:"none"}}
                      >
                      </MuiButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} className="line">
                <div>OR PAY SECURELY WITH</div>
              </Grid>
              <Grid id="creditcard_payment" container xs={12} >
                <Grid id="title_container" item xs={12} className="body-black">Credit/Debit Card
                  <Grid id="img_container">
                      <img alt ="cards" loading="lazy" src={require("../../imgs/allowed_cards.png")} style={{width:"147px"}}/>
                      <Popover image={require("../../imgs/allowed_more_payments.png")} imageWidth="120px" closeTime={3000}>
                        <div id="more_payment"/> 
                      </Popover>
                  </Grid></Grid>
                <Grid id="recurly_container">
                  <Grid container item xs={12} spacing={1}>
                    <Grid item xs={12} className="recurly-input recurly-element-card"><CardNumberElement onSubmit={handleSubmit} {...cardNumberStyle()} onChange={(state)=>{setCardBrand(state.brand); setFormData((preivous)=>({...preivous, first_six: state.firstSix}));}}/></Grid>
                    <Grid item xs={12} className="recurly-input"><InputText id="name_on_card" className="checkout-input" label="Name On Card" value={cardName} onChange={(e)=>{setCardName(e.target.value)}}/></Grid>
                    <Grid container item xs={12}>
                      <Grid item xs={12} className="body-roman">Expiration Date:</Grid>
                      <Grid container item xs={12} spacing={1}>
                        <Grid item xs={6} md={3.75} className="recurly-input recurly-element-select" ><CardMonthElement name="card_month" onSubmit={handleSubmit} {...cardMonthStyle()}/></Grid>
                        <Grid item xs={6} md={3.75} className="recurly-input recurly-element-select" ><CardYearElement name="card_year" onSubmit={handleSubmit} {...cardYearStyle()}/></Grid>
                        <Grid item xs={12} md={4.5} className="recurly-input recurly-element-cvv" ><CardCvvElement name="card_cvv" onSubmit={handleSubmit} {...cardCvvStyle()}/></Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <input id="recurly_first" data-recurly="first_name" value={cardName.split(" ")[0]} hidden readOnly/>
                <input id="recurly_last" data-recurly="last_name" value={cardName.trim().split(" ")[cardName.split(" ").length - 1]} hidden readOnly/>
                <input name="country" data-recurly="country" value={formData.bill_country} autoComplete="off" hidden readOnly/>
                <input name="postal_code" data-recurly="postal_code" value={formData.bill_zip} autoComplete="off" hidden readOnly/>
                <Grid container id="bill_container">
                  <Grid item xs={12} className="input-title">
                    Billing Address 
                    <Link className="body-link" onClick={()=>{setOpened({...opened,bill_info:!opened.bill_info})}}>{opened.bill_info?"+ Use Shipping Address":"+ Enter new billing info"}</Link>
                  </Grid>
                  <Grid className="desc" sx={{display:opened.bill_info?"":"none"}}>Please enter details that match your Credit Card info.</Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sx={{display:opened.bill_info?"none":""}}>
                      <Typography className="body-roman">
                        {formData.ship_street}, {formData.ship_apt}<br/>
                        {formData.ship_city} {formData.ship_state?formData.ship_state:null} {formData.ship_zip}, {formData.ship_country?formData.ship_country:null}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{display:opened.bill_info?"":"none"}}>
                      <InputSelect id="bill_country" name="bill_country" no_error="yes" 
                        value={formData.bill_country} 
                        onChange={(e)=>handleChange (e)} className="checkout-input" label="Country" 
                        data={filteredCountries.map((country)=>{return {value: country[1], label:country[0]}})}
                        autocomplete="billing country-name country">
                      </InputSelect>
                    </Grid>
                    <Grid item xs={12} sx={{display:opened.bill_info?"":"none"}}>
                      <InputText id="bill_zip" name="bill_zip" value={formData.bill_zip} onChange={(e)=>handleChange(e)} className="checkout-input" label="Zip / Postal Code" autocorrect="off" spellcheck="false" autocomplete="billing postal-code" autocapitalize="characters"/>
                    </Grid>
                  </Grid>
                </Grid> 
              </Grid>
              <div id="auth_3d" style={{display:threeDSecure?"":"none"}}></div>
              <Grid item xs={12}>
                <Typography className="info-label-roman" style={{marginBottom:"3px"}}>
                  <div id="lock-img"/>
                  All transactions are secure &amp; encrypted
                </Typography>
                <Typography className="info-label-roman">By placing your order, you agree that your payment method will be automatically charged at the price & plan frequency listed on this page until your subscription ends. You can cancel your subscription anytime by asking our support team for a cancellation link & using it to cancel.</Typography>
              </Grid>
              <Button className="btn-continue" text="PLACE ORDER" onClick={handleSubmit}></Button>
            </AccordionDetails> 
          </Accordion>
        </FormControl>
        <Grid container id="bottom-text-container">
          <img loading="lazy" src={isUnderMd?require("../../imgs/trust_pilot_mobile.png"):require("../../imgs/trust_pilot_desktop.png")} alt="lock" 
            style={{width:isUnderMd?"160px":"468px"}}/>
          <Typography className="info-label-roman" >
            All rights reserved Miss To Mrs®<br/>View <a href="/privacy-policy/">Privacy Policy</a> & <a href="/terms-conditions/">Terms of Use</a>
          </Typography>
        </Grid>
        </form>
      </Grid>
      <Grid container item className="checkout-right" md={6} xs={12} order={{ xs: 1, md: 2 }} flexDirection={isUnderMd?"row":"column"}>
          <Grid item className="checkout-content card-container">
            <Grid item xs={12} id="checkout-plan">
              <Grid id="plan-title" container item xs={12}>
                <div id="box-plan-img" className="mobile-show"/>
                <Grid item onClick={()=>setOpened(previous=>({
                  ...previous,
                  plan_details: !opened.plan_details
                }))}>
                  <span className="block-header-black">{planName}</span>
                  <span className="mobile-show info-label-roman">{opened.plan_details?"Hide plan summary -":"Show plan summary +"}</span>
                </Grid>
              </Grid>
              <Typography id="plan-desc" style={{paddingBottom:(price && price.now && price.now.discount==="0.00")&& !bonus.includes("sweatshirt")?"20px":""}} className={(!opened.plan_details && "mobile-hidden") + " body-roman" } 
                dangerouslySetInnerHTML={{__html:planText}}>
              </Typography>
              <Grid id="plan-promo" className="small-header" style={{display:(price && price.now && price.now.discount==="0.00") && !bonus.includes("sweatshirt")?"none":""}}>
                  <div id="promo-img"/> 
                  PROMO APPLIED: {`${formData.applied_code} ${bonus.includes("sweatshirt")?(formData.applied_code?'+ FREE BRIDE SWEATSHIRT':"FREE BRIDE SWEATSHIRT"):"+ FREE GIFT"}`}
                </Grid>
            </Grid>
          </Grid>
          <Grid container item className="checkout-total-content mobile-hidden">
            <Grid container item xs={12} className="small-text" spacing={1} display={"none"}>
              <Grid item xs={9}>
                <InputText id="code" name="code" value={formData.code} onChange={(e)=>handleChange(e)} className="checkout-input" label="Coupon Code"/>
              </Grid>
              <Grid item xs={3} id={isUnderMd?"":"coupon_input"}>
                <Button className="btn-reverse" text="APPLY" onClick={handleCouponApplied}></Button>
              </Grid>
            </Grid>
            <Grid item xs={12} className="checkout-calculate">
              <div className="line "></div>
              <Grid container item xs={12}>
                <Grid item xs={8} className="title">Miss To Mrs Subscription Plan</Grid>
                <Grid item xs={4} className="value">{(price && price.now && price.now.items[0])?`$${price.now.items[0].plan}`: ""}</Grid>
              </Grid>
              <Grid container item xs={12} className={price && price.now && price.now.discount==="0.00"?"hidden":""}>
                  <Grid item xs={10} className="title">{couponText}</Grid>
                  <Grid item xs={2} className="value">{`-$${price && price.now && price.now.discount}`}</Grid>
              </Grid>
              <Grid container item xs={12} className={!bonus.includes("namechange")?"hidden":""}>
                <Grid item xs={8} className="title">Gift: Name Change Kit</Grid>
                <Grid item xs={4} className="value"><span className="__crossed">$39.00</span><span className="__bold"> FREE</span></Grid>
              </Grid>
                <Grid container item xs={12} className={!bonus.includes("freebridesweatshirt")?"hidden":""}>
                <Grid item xs={8} className="title">Sign-up bonus: BRIDE Sweatshirt</Grid>
                <Grid item xs={4} className="value"><span className="__crossed">$59.00</span><span className="__bold"> FREE</span></Grid>
              </Grid>
              <Grid container item xs={12} className={price && price.now && price.now.items[0] && price.now.items[0].addons==="0.00"?"hidden":""}>
                <Grid item xs={8} className="title">Shipping: Green Delivery<Popover className="tooltip-icon" btnOpened="i" title={`<div class="popup-title">Shipping & Delivery</div>`} description={`<div class="popup-desc left"><div><div class="underline">Green Delivery:</div> As we utilize a network of local warehouses, this Ground Delivery option uses up to 90% less CO2 than Air Delivery of goods from remote countries.</div><div><div class="underline">Delivery Timing:</div> orders need 1-2 business days to be ready for dispatch and then most orders are delivered within ${formData.ship_country==="CA"?"5-8":(formData.ship_country==="GB"?"8-10":(formData.ship_country==="AU"?"14-18":"4-6"))} business days after you receive tracking number via email. Remote addresses may require extra time.</div>${formData.ship_country==="CA"?"<div>Ships from Canada, no extra Customs Fees</div>":""}${formData.ship_country==="GB"?"<div>No extra VAT or Customs Fees on delivery</div>":""}${formData.ship_country==="AU"?"<div>No extra Taxes or Customs Fees on delivery</div>":""}</div>`}></Popover></Grid>
                <Grid item xs={4} className="value">{price && price.now && price.now.items[0]?(price && price.now && price.now.items[0] && price.now.items[0].addons==="0.00"?`FREE`:`$${price.now.items[0].addons}`):""}</Grid>
              </Grid>
              <div className="line"></div>
              <Grid container item xs={12} className={price && price.now && price.now.taxes==="0.00"?"hidden":""}>
                <Grid item xs={8} className="title">Estimated Sales Tax{/*formData.ship_state === "ON"?"(GST/HST)":"(GST)"*/}<Popover className="tooltip-icon" btnOpened="i" title={`<div class="popup-title">Sales Tax</div>`} description={`<div class="popup-desc"><div>Miss To Mrs is required by local laws to charge applicable sales taxes for online orders and remit them to respective government tax authorities.</div></div>`}></Popover></Grid>
                <Grid item xs={4} className="value">{`$${price && price.now && price.now.taxes}`}</Grid>
              </Grid>
              <Grid container item className="checkout-result" xs={12}>
                <Grid item xs={8} className="title">Total due now (USD)</Grid>
                <Grid item xs={4} className="value">{`$${price && price.now && price.now.total}`}</Grid>
              </Grid>
              <div className="line "></div>
            </Grid>
            <img id="guarantee_img" loading="lazy" src={require("../../imgs/100_guarantee.png")} alt="100_guarantee" />
          </Grid>
        </Grid>
    </Grid>
  );
};